import saveAs, { type TypeSaveAsConfig } from './saveAs';

// ----------------------------------------------------------------------------

export type TypeSaveToJsonConfig = TypeSaveAsConfig;

// ----------------------------------------------------------------------------

function saveToJson(content: unknown, config: TypeSaveToJsonConfig = {}): void {
    const json = JSON.stringify(content);

    const blob = new Blob([json], {
        type: 'application/json',
    });

    saveAs(blob, config);
}

// ----------------------------------------------------------------------------

export default saveToJson;
